import { render, staticRenderFns } from "./FormRevalidation.vue?vue&type=template&id=193566e0&"
import script from "./FormRevalidation.vue?vue&type=script&lang=js&"
export * from "./FormRevalidation.vue?vue&type=script&lang=js&"
import style0 from "./FormRevalidation.vue?vue&type=style&index=0&id=193566e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports